module.exports = __webpack_public_path__ + "img/img-c13a0231.3e3a4e84.png";